export const GET_SECTIONS = "GET_SECTIONS";
export const GET_SECTION_BY_ID = "GET_SECTION_BY_ID";
export const UPDATE_SECTION = "UPDATE_SECTION";
export const DELETE_SECTION = "DELETE_SECTION";
export const CREATE_SECTION = "CREATE_SECTION";
